
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/guild/pricing",
      function () {
        return require("private-next-pages/[locale]/guild/pricing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/guild/pricing"])
      });
    }
  